import { render, staticRenderFns } from "./EnumSelectEditor.vue?vue&type=template&id=456467e0"
import script from "./EnumSelectEditor.vue?vue&type=script&lang=ts"
export * from "./EnumSelectEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports